import Vue from 'vue'
import * as Sentry from '@sentry/vue'
import PresentationAttributeApi from '@/api/presentationAttribute'
import constant from '@/constant'

const _state = {
  presentationAttribute: {},
}

const mutations = {
  setPresentationAttribute(state, payload) {
    state.presentationAttribute = payload
  },
  updatePresentationAttribute(state, payload) {
    Vue.set(state.presentationAttribute, payload.attributeName, payload.attributeValue)
  },
}

const actions = {
  async getPresentationAttributeAction({ commit }, presentationId) {
    try {
      const resp = await PresentationAttributeApi.getPresentationAttributes(presentationId)
      commit('setPresentationAttribute', resp.body)
      return resp.body
    } catch (error) {
      Sentry.captureMessage(new Error('Get Presentation Attribute Error'), {
        level: 'warning',
        extra: {
          presentationId,
          error,
        },
      })
      return {}
    }
  },

  async updatePresentationAttributeAction({ commit }, { presentationId, payload }) {
    commit('updatePresentationAttribute', payload)
    const resp = await PresentationAttributeApi.patchPresentationAttribute(presentationId, payload)
    return resp.body
  },
}

const _getters = {
  presentationColorPalette: (state, _, __, rootGetters) => {
    if (state.presentationAttribute?.colorPalette?.colors) {
      return state.presentationAttribute.colorPalette.colors
    }
    if (rootGetters['featureToggles/canUseNewColors']) {
      return constant.colors
    }
    return constant.legacyColors
  },
  presentationLighterColorPalette: (state, _, __, rootGetters) => {
    if (state.presentationAttribute?.colorPalette?.lighterColors) {
      return state.presentationAttribute.colorPalette.lighterColors
    }
    if (rootGetters['featureToggles/canUseNewColors']) {
      return constant.lighterColors
    }
    return constant.legacyLighterColors
  },

  presentationAttributeColorPalette: (state) => {
    return state.presentationAttribute.colorPalette || {}
  },
}

export default {
  namespaced: true,
  state: _state,
  mutations,
  actions,
  getters: _getters,
}
